/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.contentEditorModule')
.factory('BulbSelectBlockExtensionFactory', ['$interval', 'BulbBrowserService', 'MediumEditor', BulbSelectBlockExtensionFactory]);

function BulbSelectBlockExtensionFactory($interval, BulbBrowserService, MediumEditor) {

  var BulbSelectBlockExtension = MediumEditor.Extension.extend({
    name: 'bulbSelectBlock',

    selection: null,

    init: function() {
      // NOTE: This assumes that this extension is tied to exactly one editor.  If more than one editor is
      // in use, then separate instances of the extension should be created for each editor instance.
      this.editor = this.getEditorElements()[0];

      this.options = angular.merge({}, this.defaults, this.options);

      this.subscribe('editableClick', this.handleClick.bind(this));
      this.subscribe('blur', this.handleBlur.bind(this));

      // Poll for selection changes for mobile devices.
      if (BulbBrowserService.isTouchDevice() && BulbBrowserService.isMobile()) {  // jshint ignore:line
        var previousSelection = this.base.exportSelection();
        var that = this;
        $interval(function() {
          var currentSelection = that.base.exportSelection();
          if (!angular.equals(previousSelection, currentSelection)) {
            previousSelection = currentSelection;
            that.base.checkSelection();
          }
        }, 200);
      }
    },

    handleClick: function(event) {
      // Check to see if an inserted media element has been selected.
      var $element = $(event.target);
      var $selectableBlockElement = $element.closest('[selectable-block]');
      if ($selectableBlockElement.length) {
        // We are inside a block.  However, check to see if we are also inside a contenteditable, because
        // that will have precidence over the block.
        var $editableElement = $element.closest('[contenteditable="true"]');
        if ($editableElement.length && jQuery.contains($selectableBlockElement[0], $editableElement[0])) {
          this.unselectBlock();
        } else {
          this.selectBlock($selectableBlockElement[0]);
        }
      } else {
        this.unselectBlock();
      }
    },

    unselectBlock: function() {
      $(this.editor).find('.selected-block').removeClass('selected-block');
      this.blockSelected(null);
      this.selection = null;
    },

    ensureElementIsVisible: function(element) {
      var rect = element.getBoundingClientRect();
      var isInViewport = (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || this.document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || this.document.documentElement.clientWidth)
      );

      if (!isInViewport) {
        element.scrollIntoView();
      }
    },

    selectBlock: function(element) {
      var $element = $(element);
      // First, go up the heirarchy, looking for a 'selectable-block' element.
      var $selectableElement = $element.closest('[selectable-block]');
      if ($selectableElement.length === 0) {
        // Didn't find one going up, so try going down:
        $selectableElement = $element.find('[selectable-block]');
      }
      if ($selectableElement.length === 0) {
        // Didn't find a selectable element in either direction.
        // TODO CLEAN - do nothing, or select null?
        return;
      }

      $(this.editor).find('.selected-block').removeClass('selected-block');
      $selectableElement.addClass('selected-block'); // TODO CLEAN : improve name of this

      this.selection = $selectableElement[0];

      // MediumEditor.selection.selectNode uses selectNodeContents, so we really want to select the parent
      // of the content, which means we want to select the ng-transclude node:
      var transcludeNode = $selectableElement.children('[ng-transclude]')[0];

      // This is almost the same as MediumEditor's selectElement() api, but this is smarter
      // as it doesn't do a focus if the element is already has focus.  Doing such a focus sometimes causes
      // the selection to be lost.
      MediumEditor.selection.selectNode(transcludeNode, this.document);
      var selectedEditor = MediumEditor.selection.getSelectionElement(this.window);
      var focusedElement = this.base.getFocusedElement();
      if (selectedEditor !== focusedElement) {
        this.base.events.focusElement(selectedEditor);
      }

      this.ensureElementIsVisible($selectableElement[0]);
      this.blockSelected($selectableElement.closest('content-block')[0]);
    },

    handleBlur: function(event, element) {
      jQuery(element).find('.bulb-media-active').removeClass('bulb-media-active');
      $(this.editor).find('.selected-block').removeClass('selected-block');
      this.blockSelected(null);
      this.selection = null;
    }
  });

  return {
    CreateExtension: function CreateExtension(options) {
      return new BulbSelectBlockExtension(options);
    },
  };
}
